// eslint-disable-next-line import/no-extraneous-dependencies
import { createAction } from 'redux-actions';

export const getAllShippingsRequest = createAction('GET_ALL_SHIPPINGS_REQUEST');
export const getAllShippingsSuccess = createAction('GET_ALL_SHIPPINGS_SUCCESS');
export const getAllShippingsFailure = createAction('GET_ALL_SHIPPINGS_FAILURE');

export const createShippingRequest = createAction('CREATE_SHIPPING_REQUEST');
export const createShippingSuccess = createAction('CREATE_SHIPPING_SUCCESS');
export const createShippingFailure = createAction('CREATE_SHIPPING_FAILURE');
export const resetCreateShippingState = createAction('RESET_CREATE_SHIPPING_STATE');

export const updateShippingRequest = createAction('UPDATE_SHIPPING_REQUEST');
export const updateShippingSuccess = createAction('UPDATE_SHIPPING_SUCCESS');
export const updateShippingFailure = createAction('UPDATE_SHIPPING_FAILURE');
export const resetUpdateShippingState = createAction('RESET_UPDATE_SHIPPING_STATE');

export const deleteShippingRequest = createAction('DELETE_SHIPPING_REQUEST');
export const deleteShippingSuccess = createAction('DELETE_SHIPPING_SUCCESS');
export const deleteShippingFailure = createAction('DELETE_SHIPPING_FAILURE');
export const resetDeleteShippingState = createAction('RESET_DELETE_SHIPPING_STATE');

export const resetShippingState = createAction('RESET_SHIPPING_STATE');
